import { useCallback, useContext } from 'react';
import AccountPickerContext from '../../../../../../contexts/AccountPickerContext';
import isDefined from '../../../../../../isDefined';
import STORE from '../../../../../../store';
import ScorecardsContext from '../../../../../../contexts/ScorecardsContext';
import { isKpiRow } from '../../../../../../hooks/kpiTypeCheckers';
import { FindAndReplace } from '../../types';

const useFindAndReplaceScorecards = () => {
  const { scorecards } = useContext(ScorecardsContext);
  const { selectedAccountId } = useContext(AccountPickerContext);

  const replaceScorecards = useCallback(
    (metricReceipt: FindAndReplace.MetricReceipt) => {
      const { findMetricId, replaceMetricId } = metricReceipt;

      const affectedScorecardIds = metricReceipt?.affectedContentIds.scorecards;

      if (!affectedScorecardIds?.length) {
        return;
      }

      const scorecardPromises = affectedScorecardIds
        .map((scorecardId) => scorecards.find((sc) => sc.id === scorecardId))
        .filter(isDefined)
        .map((scorecard) => {
          const newScorecard: Scorecards.Scorecard = {
            ...scorecard,
            kpis: scorecard.kpis.map((k) => {
              if (!isKpiRow(k)) return k;
              return {
                ...k,
                metricId:
                  k.metricId === findMetricId ? replaceMetricId : k.metricId,
              };
            }),
          };

          return STORE.visualisations
            .getScorecardsRef({ accountId: selectedAccountId })
            .doc(scorecard.id)
            .set(newScorecard);
        });

      return Promise.all(scorecardPromises);
    },
    [scorecards, selectedAccountId],
  );

  return replaceScorecards;
};

export default useFindAndReplaceScorecards;
